export default __webpack_public_path__ + "static/media/hht2_sitcom_10.4420d447.png";